import Button from '@/components/atoms/Button';

import { useChatbotContext } from '../../_context/ChatbotContext';
import { CHATBOT_LANDING_QUESTIONS as LANDING_QUESTIONS } from '../../_constants/_const';
import { useChatbotActions } from '@/hooks/V3/useChatbotActions';

const LandingQuestion = () => {
  const { isThinking } = useChatbotContext();

  const { handleSendMessage } = useChatbotActions('action_button');
  const handleQuestionClick = (question: string) => {
    // if (isThinking) {
    //   toast({
    //     icon: '⏳',
    //     title: '세션을 준비 중입니다.\n완료되는 대로 질문할게요.',
    //     variant: 'dark',
    //   });
    //   setPendingQuestion(question);
    //   return;
    // }
    if (isThinking) {
      return;
    }

    handleSendMessage(question);
  };

  // useEffect(() => {
  //   if (sessionId && pendingQuestion) {
  //     handleSendMessage(pendingQuestion);
  //     setPendingQuestion(null);
  //   }
  // }, [sessionId]);

  return (
    <div className="flex max-w-[570px] flex-shrink-0 flex-wrap gap-[8px]">
      {LANDING_QUESTIONS.map((question, idx) => (
        <Button
          key={idx}
          variant="outline"
          className="px-[10px] py-[5px] text-gr-700 Body4S14"
          onClick={() => handleQuestionClick(question)}
        >
          {question}
        </Button>
      ))}
    </div>
  );
};

export default LandingQuestion;
